import { render, staticRenderFns } from "./SalesOrderTable.vue?vue&type=template&id=606f2862&"
import script from "./SalesOrderTable.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports